import VaultCreatedConfirmationPage from './VaultCreatedConfirmationPage.jsx';
import { authRoles } from '@/app/auth';

const VaultCreatedConfirmationConfig = {
  settings: {
    layout: {
      config: {
        navbar: {
          display: false,
        },
        toolbar: {
          display: false,
        },
        footer: {
          display: false,
        },
        leftSidePanel: {
          display: false,
        },
        rightSidePanel: {
          display: false,
        },
      },
    },
  },
  auth: authRoles.AllUsers,
  routes: [
    {
      path: 'vault-confirm',
      element: <VaultCreatedConfirmationPage />,
    },
  ],
};

export default VaultCreatedConfirmationConfig;
